export default function Numpy_ArraySplit() {
  return <div>Numpy_ArraySplit Component</div>;
}
